/**
 * Standalone funnel entry point.
 *
 * Deliberately NOT the Studio app: no shell, no navigation, no Supabase login
 * gate. This is the consumer-facing surface, so it boots straight into the
 * funnel and owns the whole page.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { lazy, Suspense } from 'react';
import FunnelFlow from './FunnelFlow';
import './app.css';

// `?compare` opens the model bake-off instead of the funnel. Development only:
// every run of it spends money on the vision API, which is not something to
// leave one query parameter away on a public site. Lazy, so it is a separate
// chunk that the published bundle never even references.
// The lazy() itself is behind the flag, not just its use: a dynamic import left
// in the source still emits a chunk into dist, even when nothing can reach it.
const ModelCompare = import.meta.env.DEV ? lazy(() => import('./dev/ModelCompare')) : null;
const compare = import.meta.env.DEV && new URLSearchParams(location.search).has('compare');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {compare && ModelCompare ? <Suspense fallback={null}><ModelCompare /></Suspense> : <FunnelFlow />}
  </StrictMode>,
);
